import React from "react";
import { withStyles } from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "../../../../../../../common/StyledToolTip";

const styles = (theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: theme.gridTextColor,
    fontSize: theme.textFontSize,
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  actionIcons: {
    cursor: "pointer",
    color: theme.iconColor,
  },
});

const DropYardViewCard = ({
  classes,
  dropYard,
  enableEdit,
  handleDeleteRegion,
}) => {
  const { dropYardName } = dropYard;

  return (
    <div className={classes.container}>
      <div>{dropYardName}</div>
      <div className={classes.actions}>
        <Tooltip title={"Edit Region"}>
          <EditIcon className={classes.actionIcons} onClick={enableEdit} />
        </Tooltip>
        <Tooltip title={"Delete Region"}>
          <DeleteOutlineIcon
            className={classes.actionIcons}
            onClick={() => handleDeleteRegion(dropYard)}
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default withStyles(styles)(DropYardViewCard);
